import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { createOrder, getPaymentMethod, sendSms, paymentByMoMo, paymentByZaloPay } from "../../../redux/actions/order_actions.js";
import { getUser, getProvinces, getDistricts, getWards, } from "../../../redux/actions/user_actions";
import { checkStockProduct } from "../../../redux/actions/products_actions.js";
import FormField from "../../../utils/FormField";
import { update, generateData, ifFormValid } from "../../../utils/FormAction";
import { Link, withRouter } from "react-router-dom";
import IndexHeader from "components/Headers/IndexHeader.js";
import { HOST_URL } from "../../../utils/misc.js";
import {
  initCart,
  setCartQuantity,
} from "../../../redux/actions/cart_actions";
import CartBlock from "../../../components/CartBlock/CartBlock";
import Swal from 'sweetalert2';
import Select from 'react-select';
import { TabContent, TabPane, Nav, NavItem, NavLink, Card, Button, CardTitle, CardText, Row, Col } from 'reactstrap';
import dateFormat from 'dateformat';
import NProgress from 'nprogress';
import Stepper from '@material-ui/core/Stepper';
import Step from '@material-ui/core/Step';
import StepLabel from '@material-ui/core/StepLabel';

const Confirm = (props) => {
    //Data Select Option
    // const options = [
    //   { value: 'cash', label: 'Tiền mặt' },
    //   { value: 'vnpay', label: 'VNPAY' },
    //   { value: 'transfer', label: 'Chuyển khoản' },
    //   { value: 'paypal', label: 'Paypal' },
    //

    // User Info
    let userInfo = JSON.parse(localStorage.getItem("user")) 

    // State user
    const userData = {
      data: {
        customerId: 0,
        accountId: 0,
        userName: "",
        fullName: "",
        birthDate: "",
        address: "",
        provinceName: "",
        districtType: "",
        districtName: "",
        wardType: "",
        wardName: "",
        homePhone: "",
        notes: ""
      }
    }

    const addressInput = {
      formError: false,
      formSuccess: "",
      formData: {
          address: {
              element: "input",
              value: "",
              config: {
                  name: "address_input",
                  type: "text",
                  placeholder: "Địa chỉ...",
              },
              validation: {
                  required: true
              },
              valid: false,
              touched: false,
              validationMessage: "",
          },
      },
    }

    const [user, setUser] = useState(userData)
    const [input, setInput] = useState(addressInput);
    const [province, setProvince] = useState(userInfo.provinceId)
    const [district, setDistrict] = useState(userInfo.districtId)
    const [ward, setWard] = useState(userInfo.wardId)
    const [provinces, setProvinces] = useState([])
    const [districts, setDistricts] = useState([])
    const [wards, setWards] = useState([])  
    const [paymentMethod, setPaymentMethod] = useState(null)
    const [paymentMethodDisplay, setPaymentMethodDisplay] = useState(null)  
    const [activeStep, setActiveStep] = useState(3);

    const getSteps = () => {
      return ['Xác nhận giỏ hàng', 'Xác nhận đơn hàng', 'Xác nhận thông tin', 'Tiến hành đặt hàng'];
    }
    const steps = getSteps();

    useEffect(() => {
      window.scrollTo(0, 0)
      NProgress.start()
      if(window.location.href.includes('MoMo')) {
        return(
          Swal.fire({
            title: 'Đặt hàng thành công!',
            text: 'Chúng tôi sẽ cố gắng liên hệ giao hàng sớm nhất có thể!',
            icon: 'success',
            confirmButtonText: 'Đóng',
            confirmButtonColor: '#000000',
          }
          ).then((ok)=>{
              if(ok){
                //Send sms to customer
                props.dispatch(sendSms())
                //Clear cart
                props.dispatch(initCart())
                props.dispatch(setCartQuantity([]))
                //Scroll to top
                window.scrollTo(0, 0)
                window.location.href = "/home"
              }
          })
        )
      }
      props.dispatch(getProvinces())
      props.dispatch(getDistricts(userInfo.provinceId))
      props.dispatch(getWards(userInfo.districtId))
      props.dispatch(getPaymentMethod())
      let userData = {
        customerId: userInfo.customerId,
        accountId: userInfo.accountId,
        userName: userInfo.userName,
        fullName: userInfo.customerName,
        birthDate: userInfo.birthDate,
        address: userInfo.address,
        provinceName: userInfo.provinceName,
        districtType: userInfo.districtType,
        districtName: userInfo.districtName,
        wardType: userInfo.wardType,
        wardName: userInfo.wardName,
        homePhone: userInfo.homePhone,
        notes: userInfo.notes
      }
      // Set value for state 
      setUser((preState) => ({
          ...preState,
          data: userData
      }))    
      let newInput = input
      newInput.formData.address.value = userData.address
      setInput(newInput)
    }, [])

  const handleCreateOrder = () => {
    let total = 0
    total = props.cart.carts.reduce((accumulator, currentValue) => { return accumulator + currentValue.quantity*currentValue.price }, 0)
    if(paymentMethod == null) {
      return(
        Swal.fire({
          title: 'Vui lòng chọn phương thức thanh toán',
          text: '',
          icon: 'warning',
          confirmButtonText: 'Đóng',
          confirmButtonColor: '#000000',
        })
      )
    }
    else if(total >= 30000000 && paymentMethodDisplay.includes('MoMo')) {
      return(
        Swal.fire({
          title: 'Vui lòng chọn phương thức thanh toán khác',
          text: 'Thanh toán MoMo chỉ ấp dụng cho đơn hàng dưới 30 triệu đồng',
          icon: 'warning',
          confirmButtonText: 'Đóng',
          confirmButtonColor: '#000000',
        })
      )
    }
    else if(!input.formData.address.value || input.formData.address.value == "") {
      return(
        Swal.fire({
          title: 'Vui lòng nhập địa chỉ',
          text: '',
          icon: 'warning',
          confirmButtonText: 'Đóng',
          confirmButtonColor: '#000000',
        })
      )
    }

    // Request List
    let checkStockList = props.cart.carts.map((element) => {
      return {
        productId: element.productId,
        quantity: element.quantity,
        notes: element.notes
      }
    })

    // Handle Check Stock Product
    props.dispatch(checkStockProduct(checkStockList)).then((res) => {
      if(res.payload.productChecked) {
        let productChecked = res.payload.productChecked
        if(props.cart.carts.length > 0 && productChecked.length == checkStockList.length && user) {          
          let data = generateData(input.formData, "update");
          let orderList = props.cart.carts.map(element => {
            return {
              productId: element.productId,
              quantity: element.quantity
            }
          })
          let dataToSubmit =  {
            orderType: activeTab,
            paymentMethodId: paymentMethod,
            customerId: userInfo.customerId,
            address: data.address,
            wardId: ward,
            districtId: district,
            provinceId: province,
            orderDetailList: orderList
          }  
          props.dispatch(createOrder(dataToSubmit)).then((res) => {
            if (res.payload) {
              if(!res.payload.result.success) {
                return(
                  Swal.fire({
                    title: 'Lỗi hệ thống!',
                    text: '',
                    icon: 'warning',
                    confirmButtonText: 'Đóng',
                    confirmButtonColor: '#000000',
                  }
                  ).then((ok)=>{
                      if(ok){
                        //Scroll to top
                        window.scrollTo(0, 0)
                        props.history.push("/home")
                      }
                  })
                )
              }
              else {
                if(paymentMethodDisplay.includes('MoMo')) {
                  props.dispatch(paymentByMoMo(userInfo.customerId)).then(res => {
                    if(res.payload) {
                      window.location.href = res.payload.paymentResponse
                    }
                  })
                }
                else if(paymentMethodDisplay.includes('ZaloPay')) {
                  props.dispatch(paymentByZaloPay(userInfo.customerId, '')).then(res => {
                    if(res.payload) {
                      handleNavigateToPayment(res.payload.paymentResponse.order_url)
                    }
                  })
                }
                else if(paymentMethodDisplay.includes('ATM')) {
                  props.dispatch(paymentByZaloPay(userInfo.customerId, 'ATM')).then(res => {
                    if(res.payload) {
                      handleNavigateToPayment(res.payload.paymentResponse.order_url)
                    }
                  })
                }
                else if(paymentMethodDisplay.includes('Visa')) {
                  props.dispatch(paymentByZaloPay(userInfo.customerId, 'CC')).then(res => {
                    if(res.payload) {
                      handleNavigateToPayment(res.payload.paymentResponse.order_url)
                    }
                  })
                }
                else {
                  return(
                    Swal.fire({
                      title: 'Đặt hàng thành công!',
                      text: 'Chúng tôi sẽ cố gắng liên hệ giao hàng sớm nhất có thể!',
                      icon: 'success',
                      confirmButtonText: 'Đóng',
                      confirmButtonColor: '#000000',
                    }
                    ).then((ok)=>{
                        if(ok){
                          //Send sms to customer
                          props.dispatch(sendSms())
                          //Clear cart
                          props.dispatch(initCart())
                          props.dispatch(setCartQuantity([]))
                          //Scroll to top
                          window.scrollTo(0, 0)
                          props.history.push("/home")
                        }
                    })
                  )
                }           
              }
            }
            else {
              Swal.fire({
                title: 'Phiên đăng nhập đã hết hạn!',
                text: 'Vui lòng đăng nhập lại',
                icon: 'warning',
                confirmButtonText: 'Đóng',
                confirmButtonColor: '#000000',
              }
              ).then((ok)=>{
                  if(ok){
                    props.history.push("/login")
                    localStorage.removeItem("user")
                  }
              })   
            }
          });
        }
        else if(productChecked.length != checkStockList.length) {
          return(
            Swal.fire({
              title: 'Mua hàng thất bại!',
              text: 'Vui lòng kiểm tra lại tình trạng các sản phẩm trong giỏ hàng',
              icon: 'warning',
              confirmButtonText: 'Đóng',
              confirmButtonColor: '#000000',
            }
            ).then((ok)=>{
                if(ok){
                  localStorage.removeItem('sessionProducts')
                  //Scroll to top
                  window.scrollTo(0, 0)
                  props.history.push("/home")
                }
            })
          )
        }
      }
      else {
        return(
          Swal.fire({
            title: 'Mua hàng thất bại!',
            text: 'Vui lòng kiểm tra lại tình trạng các sản phẩm trong giỏ hàng',
            icon: 'warning',
            confirmButtonText: 'Đóng',
            confirmButtonColor: '#000000',
          }
          ).then((ok)=>{
              if(ok){
                localStorage.removeItem('sessionProducts')
                //Scroll to top
                window.scrollTo(0, 0)
                props.history.push("/home")
              }
          })
        )
      }
    })
  }

  const handleNavigation = () => {
    props.history.push("/cart")
  }

  const handleNavigateToPayment = (url) => {
    Swal.fire({
      title: 'Đặt hàng thành công',
      text: "Vui lòng chuyển đến trang thanh toán",
      icon: 'success',
      showCancelButton: true,
      confirmButtonColor: '#000000',
      confirmButtonText: 'Thanh toán',
      cancelButtonColor: '#999897',
      cancelButtonText: 'Hủy'
    }).then((result) => {
      if (result.value) {
        window.open(url)
        //Send sms to customer
        props.dispatch(sendSms())
        //Clear cart
        props.dispatch(initCart())
        props.dispatch(setCartQuantity([]))
        //Scroll to top
        window.scrollTo(0, 0)
        props.history.push("/home")
      }
    })
  }

  // Handle Toggle TabPane
  const [activeTab, setActiveTab] = useState("0");
  const toggle = (tab) => {
    if (activeTab !== tab) {
      setActiveTab(tab);
    }
  }

  const handleChangeProvince = (selectedProvince) => {
      if(selectedProvince) {
          setProvince(selectedProvince.value)
          props.dispatch(getDistricts(selectedProvince.value)).then(res => {
              if(res.payload) {
                  if(res.payload.districts) {
                      setDistricts(res.payload.districts)
                  }
              } 
          })
      }
  }

  const handleChangeDistrict = (selectedDistrict) => {
    if(selectedDistrict) {
        setDistrict(selectedDistrict.value)
        props.dispatch(getWards(selectedDistrict.value)).then(res => {
            if(res.payload) {
                if(res.payload.wards) {
                    setWards(res.payload.wards)
                }
            } 
        })
    }
  } 

  const handleChangeWard = (selectedWard) => {
      if(selectedWard) {
          setWard(selectedWard.value)
      }
  }

  const handleChangePaymentMethod = (selectedPaymentMethod) => {
    setPaymentMethodDisplay(selectedPaymentMethod.label)
    setPaymentMethod(selectedPaymentMethod.value)
  }

  const updateForm = async (element) => {
    const newFormData = update(element, input.formData, "update");
    const newFormData_Input = {
        formError: false,
        formData: newFormData,
    };
    await setInput(newFormData_Input);
  };

  const renderUserInfo = () => {
    if(props.order.paymentMethod && props.order.paymentMethod.paymentMethod && props.user.provinces && props.user.provinces.provinces && props.user.districts && props.user.districts.districts
      && props.user.wards && props.user.wards.wards) {
      return (
        <>
          <h6 className="text-center pt-4"><b>Thông tin người mua hàng</b></h6>
          <div className="container-fluid" className="userPaymentInfo">
            <div className="row">
                <div className="col" style={{ paddingTop:20 }}>           
                  <div className="row">
                    <div className="col-md-4">Tên khách hàng:</div>
                    <div className="col-md-8"><b>{ user.data.fullName }</b></div>
                  </div>
                   <hr className="divider" />
                  <div className="row">
                    <div className="col-md-4">Địa chỉ giao hàng:</div>
                    <div className="col-md-8">   
                        <Nav className="nav" id="tabs" role="tablist">
                          <NavItem className="nav-pills">
                              <NavLink
                                  className={activeTab === "0" ? "active" : ""}
                                  onClick={() => {
                                  toggle("0");
                                  }}
                                  style={{ cursor:"pointer" }}
                              >
                                <b><i className="fas fa-map-marker-alt"></i> Địa chỉ của tôi</b>
                              </NavLink>
                          </NavItem>
                          <NavItem className="nav-pills">
                              <NavLink
                                  className={activeTab === "1" ? "active" : ""}
                                  onClick={() => {
                                  toggle("1");
                                  }}
                                  style={{ cursor:"pointer" }}
                              >
                                  <b><i className="fas fa-plus-circle"></i> Thêm mới địa chỉ</b>
                              </NavLink>
                          </NavItem>
                        </Nav>
                      <div className="row ml-2">
                        <TabContent activeTab={activeTab}>
                            <TabPane tabId="0">
                              <span style={{ fontSize: 15 }}>
                                <b>{ `(${user.data.address}, ${user.data.wardType} ${user.data.wardName}, ${user.data.districtType} ${user.data.districtName}, ${user.data.provinceName})` }</b>
                                <Link to={"/profile"} style={{ color:"black", paddingLeft: 10 }}><i className="far fa-edit"></i></Link>
                              </span>
                            </TabPane>
                            <TabPane tabId="1">
                                <div>
                                    <FormField
                                    id={"address"}
                                    formData={input.formData.address}
                                    change={(element) => updateForm(element)}
                                    />
                                </div>
                              <div className="row addressInput">
                                  <div className="col-md-4 col-xs-12 text-dark province">
                                      <Select
                                          defaultValue = {props.user.provinces.provinces.filter(option => option.value == userInfo.provinceId)}
                                          placeholder="Tỉnh thành"
                                          isSearchable
                                          options = {props.user.provinces.provinces}
                                          onChange = {handleChangeProvince} 
                                          noOptionsMessage={() => 'Chưa chọn tỉnh'}
                                          theme = { theme => ({
                                              ...theme,
                                              borderRadius: 5,
                                              colors: {
                                                  ...theme.colors,
                                                  primary: '#444444',
                                              }
                                          })}
                                      />
                                  </div>
                                  <div className="col-md-4 col-xs-12 text-dark district">
                                      <Select
                                          defaultValue = {props.user.districts.districts.filter(option => option.value == userInfo.districtId)}
                                          placeholder="Quận/Huyện"
                                          isSearchable
                                          options = {props.user.districts.districts}
                                          onChange = {handleChangeDistrict}
                                          noOptionsMessage={() => 'Chưa chọn quận/huyện'}
                                          theme = { theme => ({
                                              ...theme,
                                              borderRadius: 5,
                                              colors: {
                                                  ...theme.colors,
                                                  primary: '#444444',
                                              },
                                          })}
                                      />
                                  </div>
                                  <div className="col-md-4 col-xs-12 text-dark ward">
                                      <Select
                                          defaultValue = {props.user.wards.wards.filter(option => option.value == userInfo.wardId)}
                                          placeholder="Phường/Xã"
                                          isSearchable
                                          options = {props.user.wards.wards}
                                          onChange = {handleChangeWard}
                                          noOptionsMessage={() => 'Chưa chọn phường/xã'}
                                          theme = { theme => ({
                                              ...theme,
                                              borderRadius: 5,
                                              colors: {
                                                  ...theme.colors,
                                                  primary: '#444444',
                                              },
                                          })}
                                      />
                                  </div>
                              </div>
                            </TabPane>
                        </TabContent>
                      </div>
                    </div>
                  </div>
                   <hr className="divider" />
                  <div className="row">
                    <div className="col-md-4">Số điện thoại:</div>
                    <div className="col-md-8"><b>{ user.data.homePhone }</b></div>
                  </div>
                   <hr className="divider" />
                  <div className="row">
                    <div className="col-md-4">Ngày sinh:</div>
                    <div className="col-md-8"><b>{ dateFormat(user.data.birthDate, "dd/mm/yyyy") }</b></div>
                  </div>
                   <hr className="divider" />
                  <div className="row">
                    <div className="col-md-4" id="payType">Phương thức thanh toán:</div>
                    <div className="col-md-4">
                      <Select
                          placeholder="Phương thức thanh toán"
                          isSearchable
                          autoFocus
                          options={props.order.paymentMethod.paymentMethod}
                          onChange={handleChangePaymentMethod}
                          noOptionsMessage={() => 'Chưa chọn phương thức thanh toán'}
                          menuPlacement="top"
                          theme={theme => ({
                            ...theme,
                            borderRadius: 5,         
                            colors: {
                              ...theme.colors,
                              primary: '#444444',
                            },
                          })}              
                          // styles = {
                          //   {
                          //     control: base => ({
                          //       ...base,                       
                          //    })
                          //   }
                          // }            
                      />
                    </div>
                  </div>       
                   <hr className="divider" />
                </div>
            </div>
          </div>
        </>
      )
    }
    return(
        null
    )       
  }

  const renderCart = () => {
    if(props.cart.carts.length > 0){
      NProgress.done()
      return(
        <>
          <div className="container-fluid" style={{ marginBottom: "1%" }}>
            <div className="row" style={{ marginTop:30 }}>
              <div className="col-md-8 col-lg-6">
                <h6 className="text-center"><b>Danh sách sản phẩm</b></h6>
                  <CartBlock
                  list={props.cart.carts}
                  type="confirm"
                  title="confirm" />
              </div>
              <div className="col-md-4 col-lg-6" style={{ backgroundColor: "#f7f7f7", borderRadius: 10 }}>
                {renderUserInfo()}
              </div>
            </div>
            <div className="row" id="webPayProduct">
              <div className="col-md-6">
                <div className="text-left" style={{ marginTop:20 }}>
                  <Button className="btn btn-md btn-default btn-round o" onClick={handleNavigation}><i className="fa fa-arrow-left" aria-hidden="true"></i> Quay lại giỏ hàng</Button>
                </div>
              </div>
              <div className="col-md-6">
                <div className="text-right" style={{ marginTop:20 }}>
                  <Button className="btn btn-md btn-default btn-round o" onClick={handleCreateOrder}>Tiến hành thanh toán <i className="fa fa-arrow-right" aria-hidden="true"></i></Button>
                </div>
              </div>
            </div>
            <div className="row" id="mobilePayProduct">
              <div className="col-md-6 text-center">
                <Button className="btn btn-md btn-default btn-round o" onClick={handleNavigation}><i className="fa fa-arrow-left" aria-hidden="true"></i> Quay lại giỏ hàng</Button>
              </div>
              <div className="col-md-6 text-center">
                <Button className="btn btn-md btn-default btn-round o" onClick={handleCreateOrder}>Tiến hành thanh toán <i className="fa fa-arrow-right" aria-hidden="true"></i></Button>
              </div>
            </div>
          </div>
        </>
      )
    }
    return(
      <h3 className="text-center"><b>Chưa có sản phẩm trong giỏ hàng</b></h3>
    )
  }
  
  return (
    <>
    <IndexHeader title="Giỏ Hàng" imageUrl={HOST_URL + props.templates.templates.templateProperties.image_cartpage} minHeight="500" />
    <div className="container-fluid">
      <Stepper activeStep={activeStep} alternativeLabel>
        {steps.map((label) => (
          <Step key={label}>
            <StepLabel>{label}</StepLabel>
          </Step>
        ))}
      </Stepper>
    </div>
    <div className="container-fluid p-2">            
      {renderCart()}
    </div>
    </>
  );
};

const mapStateToProps = (state) => {
  return {
      user: state.user,
      cart: state.cart,
      order: state.order,
      templates: state.templates,
  };
};

export default connect(mapStateToProps)(withRouter(Confirm));
